import React from 'react';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import ReleaseBannerAdminScreen from './Components/ReleaseBannerAdminScreen/ReleaseBannerAdminScreen';

const ReleaseBannerAdmin = (props) => {

    const { themeSelected } = props;

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <ReleaseBannerAdminScreen className='mt-3' themeSelected={themeSelected} />
        </div>
    )
}

export default ReleaseBannerAdmin;